import TopLogout from "../components/TopLogout";
import React, { useState } from "react";
import BottomNav from "../components/BottomNav";

/* 🔴 Firebase REMOVED COMPLETELY */

export default function History() {
  const [date, setDate] = useState("");
  const [latest, setLatest] = useState(null);
  const [allReadings, setAllReadings] = useState([]);
  const [loading, setLoading] = useState(false);

  const MAX = {
    tds: 2000,
    ph: 14,
    npk: 1000,
    temp: 50,
    humidity: 100,
    light: 2000,
  };

  const getOffset = (value, max) => {
    const r = 45;
    const circ = 2 * Math.PI * r;
    if (!value && value !== 0) return circ;
    const percent = Math.min(100, (value / max) * 100);
    return circ - (percent / 100) * circ;
  };

  /* ✅ FORMAT DATE: yyyy-mm-dd → dd-mm-yyyy (DISPLAY ONLY) */
  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  };

  const downloadPDF = () => {
    if (!allReadings.length) {
      alert("No readings available to download!");
      return;
    }

    let html = `
      <html>
        <head>
          <title>History Report - ${formatDate(date)}</title>
          <style>
            body { font-family: Arial; padding: 20px; }
            h2 { text-align: center; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid #333; padding: 8px; text-align: center; }
            th { background-color: #f2f2f2; }
          </style>
        </head>
        <body>
          <h2>Smart Agriculture History Report</h2>
          <h3>Date: ${formatDate(date)}</h3>
          <table>
            <thead>
              <tr>
                <th>Time</th>
                <th>TDS</th>
                <th>pH</th>
                <th>NPK</th>
                <th>Temperature</th>
                <th>Humidity</th>
                <th>Light</th>
              </tr>
            </thead>
            <tbody>
    `;

    allReadings.forEach((r) => {
      const time = new Date(r.created_at).toLocaleTimeString();
      const npk =
        Number(r.nitrogen) + Number(r.phosphorus) + Number(r.potassium);

      html += `
        <tr>
          <td>${time}</td>
          <td>${r.tds}</td>
          <td>${r.ph}</td>
          <td>${npk}</td>
          <td>${r.temperature}°C</td>
          <td>${r.humidity}%</td>
          <td>${r.light}</td>
        </tr>`;
    });

    html += `
            </tbody>
          </table>
        </body>
      </html>`;

    const win = window.open("");
    win.document.write(html);
    win.document.close();
    setTimeout(() => win.print(), 300);
  };

  const loadHistory = async () => {
    if (!date) return alert("Select a date");

    setLoading(true);
    try {
      const res = await fetch(
        `https://laturelectronics.in/smartagri_api/get_history.php?date=${date}`
      );
      const list = await res.json();

      if (!list || list.length === 0) {
        setLatest(null);
        setAllReadings([]);
        alert("No data for this date");
        setLoading(false);
        return;
      }

      setAllReadings(list);
      setLatest(list[list.length - 1]); // last entry of day
    } catch (err) {
      console.error(err);
      alert("Error loading history");
    }

    setLoading(false);
  };

  return (
    <div style={styles.bg}>
      <img src="/com_logo.png" alt="Company Logo" style={styles.companyLogo} />

      <div style={styles.overlay}>
        <TopLogout />
        <h1 style={styles.title}>History</h1>

        <div style={styles.controls}>
          <input
            type="date"
            style={styles.datePicker}
            value={date}
            onChange={(e) => setDate(e.target.value)}
          />

          <button style={styles.loadBtn} onClick={loadHistory}>
            {loading ? "Loading..." : "Load History"}
          </button>

          <button style={styles.pdfBtn} onClick={downloadPDF}>
            Download PDF
          </button>
        </div>

        {!latest && !loading && (
          <div style={styles.emptyBox}>No data found for the selected date.</div>
        )}

        {latest && (
          <>
            <h2 style={{ marginBottom: 15 }}>Latest Reading</h2>

            <div style={styles.grid}>
              {[
                { label: "TDS", value: `${latest.tds} ppm`, key: "tds", color: "#00e676" },
                { label: "pH", value: latest.ph, key: "ph", color: "#00b0ff" },
                {
                  label: "NPK",
                  value:
                    Number(latest.nitrogen) +
                    Number(latest.phosphorus) +
                    Number(latest.potassium),
                  key: "npk",
                  color: "#ffa726",
                },
                {
                  label: "Temperature",
                  value: `${latest.temperature}°C`,
                  key: "temp",
                  color: "#ff5252",
                },
                {
                  label: "Humidity",
                  value: `${latest.humidity}%`,
                  key: "humidity",
                  color: "#40c4ff",
                },
                { label: "Light", value: latest.light, key: "light", color: "#ffd740" },
              ].map((item) => (
                <div style={styles.card} key={item.key}>
                  <h3>{item.label}</h3>
                  <div style={styles.circleContainer}>
                    <svg width="110" height="110">
                      <circle cx="55" cy="55" r="45" stroke="#555" strokeWidth="6" fill="none" />
                      <circle
                        cx="55"
                        cy="55"
                        r="45"
                        stroke={item.color}
                        strokeWidth="6"
                        fill="none"
                        strokeDasharray={2 * Math.PI * 45}
                        strokeDashoffset={getOffset(item.value, MAX[item.key])}
                      />
                    </svg>
                    <span style={styles.circleValue}>{item.value}</span>
                  </div>
                </div>
              ))}
            </div>

            <p style={{ marginTop: 15 }}>
              <b>Date:</b> {formatDate(latest.created_at)}
            </p>

            <h3 style={{ marginTop: 25 }}>All Readings of the Day:</h3>
            <div style={styles.listBox}>
              {allReadings.map((r, i) => (
                <div key={i} style={styles.listItem}>
                  <b>{new Date(r.created_at).toLocaleTimeString()} :</b>{" "}
                  TDS {r.tds}, pH {r.ph}, Temp {r.temperature}°C,
                  Humidity {r.humidity}%, Light {r.light}
                </div>
              ))}
            </div>
          </>
        )}

        <BottomNav />
      </div>
    </div>
  );
}

/* ---------- STYLES (UNCHANGED) ---------- */
const styles = {
  bg: {
    backgroundImage: "url('/bg4.png')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    minHeight: "100vh",
  },
  companyLogo: {
    position: "absolute",
    top: "10px",
    left: "10px",
    width: "140px",
    zIndex: 1000,
  },
  overlay: {
    background: "rgba(0,0,0,0.55)",
    minHeight: "100vh",
    padding: "20px",
    paddingBottom: "140px",
    textAlign: "center",
    color: "white",
  },
  title: { fontSize: 32, fontWeight: "bold", color: "#a8ff60" },
  controls: {
    marginTop: 10,
    marginBottom: 20,
    display: "flex",
    gap: 10,
    justifyContent: "center",
  },
  datePicker: { padding: 8, borderRadius: 8, border: "none" },
  loadBtn: {
    padding: "8px 14px",
    background: "#00c853",
    border: "none",
    color: "white",
    borderRadius: 8,
    cursor: "pointer",
  },
  pdfBtn: {
    padding: "8px 14px",
    background: "#1e88e5",
    border: "none",
    color: "white",
    borderRadius: 8,
    cursor: "pointer",
  },
  emptyBox: {
    marginTop: 20,
    background: "rgba(255,255,255,0.1)",
    padding: 15,
    borderRadius: 10,
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: 18,
    marginTop: 15,
  },
  card: {
    background: "rgba(0,0,0,0.35)",
    borderRadius: 14,
    padding: 18,
  },
  circleContainer: {
    position: "relative",
    width: 110,
    height: 110,
    margin: "auto",
  },
  circleValue: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    fontWeight: "bold",
  },
  listBox: {
    background: "rgba(255,255,255,0.08)",
    padding: 15,
    marginTop: 15,
    borderRadius: 10,
  },
  listItem: {
    textAlign: "left",
    marginBottom: 5,
  },
};
